// extracted by mini-css-extract-plugin
var _1 = "WysiwygEditor-moduleskeleton__SckBG Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "skeleton" }
